<template>
  <div class="container">
    <div class="activityFormWrapper" v-if="dataReady">
      <div class="avtivity-F-H">
        <div class="title">{{title}}</div>
      </div>
      <div class="activity-form">
        <van-form @submit="onSubmit" ref="activity" @failed="onFailed" :validate-first="true">
          <div class="activity_form_item" v-for="(item, index) in activityForm" :key="index">
            <div class="propertyarray_title">
              <h2>{{item.propertytype}}</h2>
            </div>
            <div class="propertyarray_box">
              <div
                :class="(property.fieldtype === 'text' || property.fieldtype === 'textarea' || property.fieldtype === 'select' || property.fieldtype === 'datetime') ? 'propertyarray_list hasborder' : 'propertyarray_list'"
                v-for="(property, num) in item.propertyarray"
                :key="num"
              >
                <van-field
                  v-if="(property.fieldtype === 'text' && property.fieldinfo === '身份证号码') || property.fieldinfo === '身份证号码'"
                  :name="property.fieldname"
                  v-model="activityData[property.fieldname]"
                  :placeholder="'请输入' + property.fieldinfo"
                  :rules="[{ required: property.fieldnull === 'false', message: '请输入' + property.fieldinfo }]"
                  @blur="fill"
                >
                  <template #label>
                    <p class="activity_form_label"><span v-if="property.fieldnull === 'false'">*</span>{{property.fieldinfo}}</p>
                  </template>
                </van-field>
                <van-field
                  v-if="property.fieldtype === 'text' && property.fieldinfo != '身份证号码' && property.fieldinfo != '出生日期' && property.fieldinfo != '作品简介'"
                  :name="property.fieldname"
                  v-model="activityData[property.fieldname]"
                  :placeholder="'请输入' + property.fieldinfo"
                  :rules="[{ required: property.fieldnull === 'false', message: '请输入' + property.fieldinfo }]"
                >
                  <template #label>
                    <p class="activity_form_label"><span v-if="property.fieldnull === 'false'">*</span>{{property.fieldinfo}}</p>
                  </template>
                </van-field>
                <div class="zpjj" v-if="(property.fieldtype === 'textarea' && property.fieldinfo === '作品简介') || property.fieldinfo === '作品简介'">
                  <van-field
                    v-model="activityData[property.fieldname]"
                    :name="property.fieldname"
                    rows="2"
                    autosize
                    type="textarea"
                    :placeholder="'请输入' + property.fieldinfo"
                    maxlength="200"
                    show-word-limit
                    :rules="[{ required: property.fieldnull === 'false', message: '请输入' + property.fieldinfo }]"
                  >
                    <template #label>
                      <p class="activity_form_label"><span v-if="property.fieldnull === 'false'">*</span>{{property.fieldinfo}}</p>
                    </template>
                  </van-field>
                  <p class="zpjjTips">(作品创新点或创作思路梗概，不超过200字)</p>
                </div>
                <van-field
                  v-if="property.fieldtype === 'textarea' && property.fieldinfo != '身份证号码' && property.fieldinfo != '出生日期' && property.fieldinfo != '作品简介'"
                  :name="property.fieldname"
                  v-model="activityData[property.fieldname]"
                  rows="2"
                  autosize
                  type="textarea"
                  :placeholder="'请输入' + property.fieldinfo"
                  :rules="[{ required: property.fieldnull === 'false', message: '请输入' + property.fieldinfo }]"
                >
                  <template #label>
                    <p class="activity_form_label"><span v-if="property.fieldnull === 'false'">*</span>{{property.fieldinfo}}</p>
                  </template>
                </van-field>
                <van-field
                  v-if="property.fieldtype === 'radio' && property.fieldinfo != '身份证号码' && property.fieldinfo != '出生日期' && property.fieldinfo != '作品简介'"
                  :rules="[{ required: property.fieldnull === 'false', message: '请选择' + property.fieldinfo }]"
                  :name="property.fieldname"
                  class="showErrorMes"
                >
                  <template #label>
                    <p class="activity_form_label"><span v-if="property.fieldnull === 'false'">*</span>{{property.fieldinfo}}</p>
                  </template>
                  <van-radio-group v-model="activityData[property.fieldname]" slot="input">
                    <van-radio
                      v-for="(radioItem, radioindex) in property.fielddata"
                      :key="radioindex"
                      :name="radioItem"
                    >
                      {{radioItem}}
                    </van-radio>
                  </van-radio-group>
                </van-field>
                <van-field
                  v-if="property.fieldtype === 'checkbox' && property.fieldinfo != '身份证号码' && property.fieldinfo != '出生日期' && property.fieldinfo != '作品简介'"
                  :rules="[{ required: property.fieldnull === 'false', message: '请选择' + property.fieldinfo }]"
                  :name="property.fieldname"
                  class="showErrorMes"
                >
                  <template #label>
                    <p class="activity_form_label"><span v-if="property.fieldnull === 'false'">*</span>{{property.fieldinfo}}</p>
                  </template>
                  <van-checkbox-group
                    v-model="activityData[property.fieldname]"
                    slot="input"
                  >
                    <van-checkbox
                      v-for="(checkboxitem, checkboxindex) in property.fielddata"
                      :key="checkboxindex"
                      :name="checkboxitem"
                      shape="square"
                    >
                      {{checkboxitem}}
                    </van-checkbox>
                  </van-checkbox-group>
                </van-field>
                <van-field
                  :ref="property.fieldinfo === '证件类型' ? 'zjlx' : ''"
                  v-if="property.fieldtype === 'select' && property.fieldinfo != '身份证号码' && property.fieldinfo != '出生日期' && property.fieldinfo != '作品简介'"
                  readonly
                  clickable
                  v-model="activityData[property.fieldname]"
                  :name="property.fieldname"
                  :placeholder="'点击选择' + property.fieldinfo"
                  @click="showPicker(property.fieldname, property.fieldinfo)"
                  :rules="[{ required: property.fieldnull === 'false', message: '请选择' + property.fieldinfo }]"
                >
                  <template #label>
                    <p class="activity_form_label"><span v-if="property.fieldnull === 'false'">*</span>{{property.fieldinfo}}</p>
                  </template>
                </van-field>
                <van-popup v-model="show[property.fieldname]" position="bottom" v-if="property.fieldtype === 'select' && property.fieldinfo != '身份证号码' && property.fieldinfo != '出生日期' && property.fieldinfo != '作品简介'">
                  <van-picker
                    show-toolbar
                    :columns="property.fielddata"
                    @confirm="onConfirm"
                    @cancel="onCancel(property.fieldname)"
                  />
                </van-popup>
                <van-field
                  v-if="(property.fieldtype === 'datetime' && property.fieldinfo != '身份证号码' && property.fieldinfo != '作品简介') || property.fieldinfo === '出生日期'"
                  readonly
                  v-model="activityData[property.fieldname]"
                  :name="property.fieldname"
                  :placeholder="(autoFill && property.fieldinfo === '出生日期') ? brithdayph : '点击选择' + property.fieldinfo"
                  :rules="[{ required: property.fieldnull === 'false', message: (autoFill && property.fieldinfo === '出生日期') ? '出生日期获取失败，请确保身份证填写正确！' : '请选择' + property.fieldinfo }]"
                  @click="showPicker(property.fieldname, property.fieldinfo)"
                >
                  <template #label>
                    <p class="activity_form_label"><span v-if="property.fieldnull === 'false'">*</span>{{property.fieldinfo}}</p>
                  </template>
                </van-field>
                <van-popup v-model="show[property.fieldname]" position="bottom" v-if="(property.fieldtype === 'datetime' && property.fieldinfo != '身份证号码' && property.fieldinfo != '作品简介') || property.fieldinfo === '出生日期'">
                  <van-datetime-picker
                    type="date"
                    :formatter="formatter"
                    :min-date="mindate"
                    v-model="currentdate"
                    @confirm="onConfirmDate"
                    @cancel="onCancel(property.fieldname)"
                  />
                </van-popup>
                <div class="upfile">
                  <van-field
                    v-if="property.fieldtype === 'file' && property.fieldinfo != '身份证号码' && property.fieldinfo != '出生日期' && property.fieldinfo != '作品简介'"
                    :name="property.fieldname"
                    type="file"
                    :data-name="property.fieldname"
                    :id="property.fieldname"
                    @change="upfile"
                  >
                    <template #label>
                      <p class="activity_form_label"><span v-if="property.fieldnull === 'false'">*</span>{{property.fieldinfo}}</p>
                    </template>
                  </van-field>
                  <div class="file_btn" v-if="property.fieldtype === 'file'">
                    <i class="iconfont iconjia1"></i>
                    选择文件
                  </div>
                </div>
                <p class="fileupTips" v-if="property.fieldtype === 'file'">(上传文件最大不超过100M)</p>
                <div class="show_files" v-if="property.fieldtype === 'file'">
                  <p v-if="activityData[property.fieldname].wordArr.length > 0" class="word_p"><i class="iconfont iconwenjian"></i>文件作品</p>
                  <div class="word_file">
                    <div
                      class="word_file_list"
                      v-for="(wordfile, wordfileindex) in activityData[property.fieldname].wordArr"
                      :key="wordfileindex"
                    >
                      {{wordfile.filename}}
                      <i class="iconfont iconx" @click="deletefile('word', wordfile.filename, property.fieldname)"></i>
                    </div>
                    <!-- <div class="word_file_list">上传的文件名<i class="iconfont iconx"></i></div> -->
                  </div>
                  <p v-if="activityData[property.fieldname].imgArr.length > 0" class="img_p"><i class="iconfont icontupian"></i>图片作品</p>
                  <div class="img_file">
                    <div
                      class="img_file_list"
                      v-for="(imgfile, imgfileindex) in activityData[property.fieldname].imgArr"
                      :key="imgfileindex"
                    >
                      <img :src="imgfile.fileurl" alt="">
                      <i class="iconfont iconshanchu1" @click="deletefile('img', imgfile.filename, property.fieldname)"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="activity_form_item">
            <div class="propertyarray_title">
              <h2>作品组别</h2>
            </div>
            <div class="propertyarray_box">
              <div class="propertyarray_list hasborder">
                <van-field
                  readonly
                  clickable
                  v-model="grouptype"
                  :name="grouptype"
                  placeholder="点击选择作品组别"
                  :rules="[{ required: true, message: '点击选择作品组别' }]"
                  @click="showGT = true"
                />
                <van-popup v-model="showGT" position="bottom">
                  <van-picker
                    show-toolbar
                    :columns="grouptypeData"
                    @confirm="onConfirmGT"
                    @cancel="showGT = false"
                  />
                </van-popup>
              </div>
            </div>
          </div>
          <div class="activity_form_item">
            <div class="propertyarray_title">
              <h2>作品类型</h2>
            </div>
            <div class="propertyarray_box">
              <div class="propertyarray_list hasborder">
                <van-field
                  readonly
                  clickable
                  v-model="worktype"
                  :name="grouptype"
                  placeholder="点击选择作品类型"
                  :rules="[{ required: true, message: '点击选择作品类型' }]"
                  @click="showWK = true"
                />
                <van-popup v-model="showWK" position="bottom">
                  <van-picker
                    show-toolbar
                    :columns="worktypeData"
                    @confirm="onConfirmWK"
                    @cancel="showWK = false"
                  />
                </van-popup>
              </div>
            </div>
          </div>
          <div class="activity_form_item">
            <div class="propertyarray_title">
              <h2>报名费用</h2>
            </div>
            <div class="propertyarray_box fee_box">
              {{isfee === 1 ? '* 本次活动需要交纳'+ fee +'元报名费用' : '* 本次活动不收取任何报名费'}}
            </div>
          </div>
          <div class="activity_form_item" v-if="statementText.length > 0">
            <div class="propertyarray_title">
              <h2>声明条款</h2>
            </div>
            <div class="propertyarray_box">
              <div class="propertyarray_list">
                <div class="statementtext">
                  {{statementText}}
                </div>
                <van-field>
                  <van-checkbox v-model="statement" slot="input" shape="square">我已阅读并同意以上原创声明条款</van-checkbox>
                </van-field>
              </div>
            </div>
          </div>
          <div class="activity_form_item" v-if="isfee === 1">
            <div class="propertyarray_title">
              <h2>支付方式</h2>
            </div>
            <div class="propertyarray_box pay_type">
              <van-radio-group v-model="paytype">
                <van-cell-group>
                  <van-cell clickable @click="paytype = '0'" v-if="iswx">
                    <div slot="title" class="pay_type_item">
                      <i class="iconfont iconweixinzf_"></i>微信
                    </div>
                    <van-radio slot="right-icon" name="0" />
                  </van-cell>
                  <van-cell clickable @click="paytype = '1'" v-if="!iswx">
                    <div slot="title" class="pay_type_item">
                      <i class="iconfont iconzhifubzf_"></i>支付宝
                    </div>
                    <van-radio slot="right-icon" name="1" />
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </div>
          </div>
          <div class="btnwrapper">
            <van-button id="submitBtn" block type="info" native-type="submit" :disabled="submiting">
              立即报名
            </van-button>
          </div>
        </van-form>
<!--         <div class="activity-footer">
          <div class="answer-navigator__button finish_button" @click="signup()">立即报名</div>
        </div> -->
      </div>
    </div>
    <div class="loading" v-if="!dataReady">
      <van-loading type="spinner" color="#1989fa" size="50px" />
    </div>
    <van-loading class="fileload" type="spinner" vertical color="#1989fa" v-if="fileloading">
      <span v-if="videoUpload">{{Math.round(percent * 100)}}%</span>
    </van-loading>
  </div>
</template>

<script>
  import API from '../../interface/api'
  import HOSTURL from '../../interface/host'
  import $ from 'jquery'
  import TcVod from 'vod-js-sdk-v6'
  import wx from 'weixin-js-sdk'
  import throttle from 'lodash/throttle'
  const u = navigator.userAgent
  // var tcVod
  export default {
    name: 'activityForm',
    data () {
      return {
        iswx: false,
        dataReady: true,
        fileloading: false,
        submiting: false,
        title: '',
        activityid: this.$route.query.id,
        activityForm: [],
        activityData: {},
        requirefile: [],
        worktype: '',
        showWK: false,
        worktypeData: [],
        grouptype: '',
        showGT: false,
        grouptypeData: [],
        statement: false,
        statementText: '',
        show: {},
        currentShow: '',
        currentShowText: '',
        fee: 0,
        isfee: 0,
        paytype: '',
        autoFill: '',
        mindate: new Date(1900, 0, 1),
        currentdate: new Date(),
        signature: '',
        tcVod: null,
        videoUpload: false,
        percent: 0,
        brithdayph: ''
      }
    },
    created () {
      // tcVod = new TcVod({
      //   getSignature: this.getSignature
      // })
      if (u.indexOf('MicroMessenger') > -1) {
        this.iswx = true
        this.paytype = '0'
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let url=''
        if (isAndroid) {
          url=location.href
        }
        if (isIOS) {
          url=location.href.split('#')[0]  //hash后面的部分如果带上ios中config会不对
        }
        this.$fetch.get(API.GETWECHATINVOKESIGN, {
          url: url
        }).then(response => {
          let data = response.data
          wx.config({
            beta: true,
            debug: false,
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })
        })
      } else {
        this.iswx = false
        this.paytype = '1'
      }
      this.$toast.allowMultiple()
      this.$fetch.get(API.ACFINDACTIVITY, {
        activityid: this.$route.query.id
      }).then(res => {
        // console.log(res)
        if (res.status === 200) {
          this.title = res.data.title
          this.activityForm = res.data.propertyjson
          this.statementText = res.data.statement
          this.worktypeData = res.data.worktypelist
          this.grouptypeData = res.data.grouptypelist
          this.fee = res.data.fee
          this.isfee = res.data.isfee
          var hasIDcard = false
          var hasBrithday = ''
          for(var i = 0; i < res.data.propertyjson.length; i++) {
            for (var k = 0; k < res.data.propertyjson[i].propertyarray.length; k++) {
              var type = res.data.propertyjson[i].propertyarray[k].fieldtype
              var name = res.data.propertyjson[i].propertyarray[k].fieldname
              if (type === 'checkbox') {
                // this.activityData[name] = []
                this.$set(this.activityData, name, [])
              } else if (type === 'select' || type === 'datetime') {
                // this.show[name] = false
                // this.activityData[name] = ''
                this.$set(this.show, name, false)
                this.$set(this.activityData, name, '')
              } else if (type === 'file') {
                this.$set(this.activityData, name, {imgArr: [], wordArr: []})
              } else {
                // this.activityData[name] = ''
                this.$set(this.activityData, name, '')
              }
              if (type === 'file' && res.data.propertyjson[i].propertyarray[k].fieldnull === 'false') {
                this.requirefile.push({
                  info: res.data.propertyjson[i].propertyarray[k].fieldinfo,
                  name: name
                })
              }
              if (res.data.propertyjson[i].propertyarray[k].fieldinfo === '身份证号码') {
                hasIDcard = true
              }
              if (res.data.propertyjson[i].propertyarray[k].fieldinfo === '出生日期') {
                hasBrithday = res.data.propertyjson[i].propertyarray[k].fieldname
              }
            }
          }
          if (hasIDcard && hasBrithday) {
            this.autoFill = hasBrithday
            this.$nextTick(function () {
              if (this.$refs.zjlx) {
                this.brithdayph = '点击选择出生日期'
              } else {
                this.brithdayph = '出生日期根据身份证号码自动填充'
              }
            })
          } else {
            this.brithdayph = '点击选择出生日期'
          }
          // console.log(this.activityData)
        } else {
          var msg = res.message ? res.message : '活动请求失败，请稍后再试！'
          this.$toast.fail(msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    methods: {
      getSignature () {
        return new Promise( (resolve, reject) => {
          this.$fetch.post(API.VODUPLOADSIGN, JSON.stringify({
            "Action": "GetUgcUploadSign"
          })).then(response => {
            // console.log(response)
            this.signature =  response.data.sign
            resolve(true)
          }).catch(err => {
            reject(false)
          })
        });
      },
      formatter(type, val) {
        if (type === 'year') {
          return `${val}年`
        } else if (type === 'month') {
          return `${val}月`
        } else if (type === 'day') {
          return `${val}日`
        }
        return val
      },
      onConfirmGT (value) {
        this.grouptype = value
        this.showGT = false
      },
      onConfirmWK (value) {
        this.worktype = value
        this.showWK = false
      },
      showPicker (type, name) {
        if (name === '出生日期' && this.autoFill) {
          if (this.$refs.zjlx && this.$refs.zjlx[0].value === '身份证') {
            return
          } else {
            this.$set(this.show, type, true)
            this.currentShow = type
            this.currentShowText = ''
          }
        } else if (name === '证件类型') {
          this.$set(this.show, type, true)
          this.currentShow = type
          this.currentShowText = name
        } else {
          this.$set(this.show, type, true)
          this.currentShow = type
          this.currentShowText = ''
        }
      },
      onConfirm (value) {
        // console.log(value)
        if (this.currentShowText === '证件类型' && value === '身份证' && this.autoFill) {
          this.$set(this.activityData, this.currentShow, value)
          this.$set(this.show, this.currentShow, false)
          this.brithdayph = '出生日期根据身份证号码自动填充'
        } else if (this.currentShowText === '证件类型' && value !== '身份证' && this.autoFill) {
          this.$set(this.activityData, this.currentShow, value)
          this.$set(this.show, this.currentShow, false)
          this.brithdayph = '点击选择出生日期'
        } else {
          this.$set(this.activityData, this.currentShow, value)
          this.$set(this.show, this.currentShow, false)
        }
      },
      onConfirmDate (value) {
        // console.log(value)
        var year = value.getFullYear()
        var month = value.getMonth() + 1
        var day = value.getDate()
        month = month < 10 ? '0' + month : month; 
        day = day < 10 ? ('0' + day) : day; 
        var dateval = year + '-' + month + '-' + day
        // console.log(dateval)
        this.$set(this.activityData, this.currentShow, dateval)
        this.$set(this.show, this.currentShow, false)
      },
      onCancel (type) {
        // console.log(type)
        this.$set(this.show, type, false)
      },
      upfile (e) {
        // console.log(e)
        this.fileloading = true
        $("#" + e.target.dataset.name).attr('disabled', true)
        let file = e.target.files[0]
        // console.log(file)
        if (file.size > 209715200) {
          this.$toast('上传文件最大不超过100M')
          $("#" + e.target.dataset.name).attr('disabled', false)
          this.fileloading = false
          return
        }

        let formData = new FormData()
        formData.append('file', file)
        var filename = file.name
        var fileArrs = this.activityData[e.target.dataset.name]
        var exts = filename.lastIndexOf('.') > -1 ? filename.slice(filename.lastIndexOf('.') + 1) : ''

        if (file.type.indexOf('video') > -1) {
          this.videoUpload = true
          this.percent = 0
          this.uploadFile(file, e.target.dataset.name)
        } else {
          // if (exts === 'jpg' || exts === 'png' || exts === 'jpeg') {
          //   for (var i = 0; i < fileArrs.imgArr.length; i++) {
          //     if (fileArrs.imgArr[i].filename === file.name) {
          //       isupload = true
          //     }
          //   }
          // } else {
          //   for (var k = 0; k < fileArrs.wordArr.length; k++) {
          //     if (fileArrs.wordArr[k].filename === file.name) {
          //       isupload = true
          //     }
          //   }
          // }
          // if (isupload) {
          //   this.$toast('该文件已经上传')
          //   this.fileloading = false
          //   $("#" + e.target.dataset.name).attr('disabled', false)
          //   return
          // }
          this.videoUpload = false
          $.ajax({
            url: HOSTURL + API.LOCALFILE,
            type: 'POST',
            data: formData,
            cache: false,
            processData: false, 
            contentType: false,
            success: res => {
              // console.log(res)
              // console.log($("#" + e.target.dataset.name))
              if (res.status === 200) {
                // var filename = res.data[0].source_name
                // console.log(exts)
                var fileobj = {
                  filename: res.data[0].source_name,
                  filesize: res.data[0].file_size,
                  fileurl: res.data[0].server_path
                }
                // var fileArr = this.activityData[e.target.dataset.name]
                if (exts.toLowerCase() === 'jpg' || exts.toLowerCase() === 'png' || exts.toLowerCase() === 'jpeg' || exts.toLowerCase() === 'gif') {
                  fileArrs.imgArr.push(fileobj)
                } else {
                  fileArrs.wordArr.push(fileobj)
                }
                this.$set(this.activityData, e.target.dataset.name, fileArrs)
                // console.log(this.activityData)
              } else {
                var msg = res.message ? res.message : '文件上传失败，请重新上传！'
                this.$toast.fail(msg)
              }
              this.fileloading = false
              $("#" + e.target.dataset.name).val('')
              $("#" + e.target.dataset.name).attr('disabled', false)
            },
            error: err => {
              this.fileloading = false
              $("#" + e.target.dataset.name).val('')
              $("#" + e.target.dataset.name).attr('disabled', false)
              console.log(err)
            }
          })
        }
      },
      async uploadFile (file, fileN) {
        var _this = this
        if (!this.signature && !await this.getSignature()) {
          console.log(`获取视频上传签名失败`)
          _this.fileloading = false
          $("#" + fileN).val('')
          $("#" + fileN).attr('disabled', false)
          return
        }
        if (!this.tcVod) {
          this.tcVod = new TcVod({
              getSignature: () => this.signature,
          })
        }
        this.uploader = this.tcVod.upload({
          mediaFile: file, // file是js的文件引用
        })
        this.uploader.on('media_progress', info => {
          // console.log(info)
          this.percent = info.percent
        })
        this.uploader.done().then(info => {
          // console.log(info)
          var filename = file.name
          var fileArrs = _this.activityData[fileN]
          var fileobj = {
            filename: file.name,
            filesize: file.size,
            fileurl: info.video.url
          }
          fileArrs.wordArr.push(fileobj)
          _this.$set(_this.activityData, fileN, fileArrs)
          _this.fileloading = false
          $("#" + fileN).val('')
          $("#" + fileN).attr('disabled', false)
          // 上传成功事件
          // 返回数据格式如下：{fileId: "xxx", vodeo: {url: "http://xxx.mp4",verify_content: "xxx"}}
        }).catch(function (err) {
            console.log(err)
            var msg = '文件上传失败，请重新上传！'
            _this.$toast.fail(msg)
            _this.fileloading = false
            $("#" + fileN).val('')
            $("#" + fileN).attr('disabled', false)
          })
      },
      deletefile (filetype, name, propertyname) {
        let deleteloading = this.$toast.loading({
          message: '删除中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0
        })
        var fileList = this.activityData[propertyname]
        if (filetype === 'img') {
          for (var i = 0; i < fileList.imgArr.length; i++) {
            if (fileList.imgArr[i].filename === name) {
              fileList.imgArr.splice(i, 1)
            }
          }
        } else {
          for (var k = 0; k < fileList.wordArr.length; k++) {
            if (fileList.wordArr[k].filename === name) {
              fileList.wordArr.splice(k, 1)
            }
          }
        }
        this.$set(this.activityData, propertyname, fileList)
        deleteloading.clear()
      },
      onSubmit: throttle(function() {
        var requirefileOK = true
        for (var i = 0; i < this.requirefile.length; i++) {
          var name = this.requirefile[i].name
          var info = this.requirefile[i].info
          if (this.activityData[name].imgArr.length === 0 && this.activityData[name].wordArr.length === 0) {
            this.$toast.fail(info + '不能为空！')
            requirefileOK = false
            return
          }
        }
        if (!requirefileOK) {
          return
        }
        if (this.statementText.length > 0 && !this.statement) {
          this.$toast.fail('请先阅读并同意原创声明条款')
          return
        }
        this.submiting = true
        let submitloading = this.$toast.loading({
          message: '报名中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0
        })
        // console.log(this.activityData)
        var propertyjson = []
        for(let item in this.activityData) {
          var obj = {}
          if (Array.isArray(this.activityData[item])) {
            obj = {
              fieldname: item,
              fieldvalue: this.activityData[item].join(',')
            }
          } else if (Object.prototype.toString.call(this.activityData[item]) === '[object Object]') {
            var newArr = this.activityData[item].imgArr.concat(this.activityData[item].wordArr)
            obj = {
              fieldname: item,
              fieldvalue: newArr
            }
          } else {
            obj = {
              fieldname: item,
              fieldvalue: this.activityData[item]
            }
          }
          propertyjson.push(obj)
        }
        // console.log(propertyjson)
        let formDataObj = {}
        if (this.statementText.length > 0) {
          formDataObj = {
            activityid: this.$route.query.id,
            statement: this.statement,
            worktype: this.worktype,
            grouptype: this.grouptype,
            propertyjson: JSON.stringify(propertyjson)
          }
        } else {
          formDataObj = {
            activityid: this.$route.query.id,
            worktype: this.worktype,
            grouptype: this.grouptype,
            propertyjson: JSON.stringify(propertyjson)
          }
        }
        var _this = this
        if (this.isfee === 1) {
          formDataObj.amount = this.fee
          formDataObj.creditamount = 0
          formDataObj.payamount = this.fee
          formDataObj.paytype = this.paytype
          // console.log(formDataObj)
          this.$fetch.post(API.ACTIVITYSIGNUPSAVE, formDataObj).then(response => {
            // console.log(res)
            submitloading.clear()
            if (response.status === 405) {
              var msg = response.message ? response.message + '请至个人中心》我的报名进行查看' : '你已报名，请至个人中心》我的报名进行查看';
              this.$toast({
                duration: 4000,
                message: msg
              })
              this.submiting = false
              return
            }
            if (response.status !== 200) {
              this.$toast.fail({
                message: res.message,
                duration: 4000
              })
              this.submiting = false
              return
            }
            // console.log(response)
            if (this.paytype === '1') {
              this.aliorderpay(response.data.orderno)
            } else {
              this.orderPay(response.data.orderno, response.data.orderid)
            }
          }).catch(err => {
            console.log(err)
            submitloading.clear()
            this.submiting = false
            var msg = err.message ? err.message : '报名申请失败，请稍后尝试！'
            this.$toast.fail({
              message: msg,
              duration: 4000
            })
          })
        } else {
          this.$fetch.post(API.ACTIVITYSIGNUPSAVE, formDataObj).then(res => {
            // console.log(res)
            submitloading.clear()
            if (res.status === 405) {
              var msg = res.message ? res.message + '请至个人中心》我的报名进行查看' : '你已报名，请至个人中心》我的报名进行查看';
              this.$toast({
                duration: 4000,
                message: msg
              })
              this.submiting = false
              return
            }
            if (res.status !== 200) {
              this.$toast.fail({
                message: res.message,
                duration: 4000
              })
              this.submiting = false
              return
            }
            this.$toast.success({
              message: '报名申请成功!',
              forbidClick: true
            })
            setTimeout(function(){
              _this.$router.replace({
                path: '/activity/result',
                query: {
                  activityid: _this.$route.query.id
                }
              })
            }, 2000)
          }).catch(err => {
            console.log(err)
            submitloading.clear()
            this.submiting = false
            var msg = err.message ? err.message : '报名申请失败，请稍后尝试！'
            this.$toast.fail({
              message: msg,
              duration: 4000
            })
          })
        }
      }, 3000, { 'trailing': false }),
      orderPay (orderno, id) {
        if (u.indexOf('MicroMessenger') > -1) {
          this.$fetch.post(API.WECHATPAY, {
            orderno: orderno
          }).then(response => {
            // console.log(response.data)
            let data = response.data
            let options = {
              timestamp: data.timeStamp, // 时间戳，自1970年以来的秒数
              nonceStr: data.nonceStr, // 随机串
              package: data.package,
              signType: data.signType, // 微信签名方式:
              paySign: data.paySign, // 微信签名
              success: (res) => {
                // console.log(res)
                if (res.errMsg === 'chooseWXPay:ok') {
                  this.$router.replace({path:'/activity/result', query: {id: id}})
                } else {
                  this.$router.replace({path:'/activity/result', query: {id: id}})
                }
              },
              cancel: (res) => {
                // console.log(res)
                this.$toast.fail('已取消订单支付')
                this.submiting = false
              },
              fail: (res) => {
                this.$router.replace({path:'/activity/result', query: {id: id}})
              }
            }
            // 唤起微信支付
            wx.chooseWXPay(options)
          })
        } else {
          this.submiting = false
          this.$toast.fail('请在微信客户端内支付')
        }
      },
      aliorderpay (orderno) {
        this.$fetch.post(API.ALIPAY, {
          orderno: orderno
        }).then(response => {
          // console.log(response)
          if (response.status !== 200) {
            var msg = response.message? response.message : '支付宝唤起支付失败，请刷新重试！'
            this.$toast.fail(msg)
            return
          }
          window.location.href = response.data.payurl
          // this.alipayWap = response
        }).catch(err => {
          console.log(err)
        })
      },
      onFailed (object) {
        // console.log(object)
        var name = object.errors[0].name
        this.$refs.activity.scrollToField(name)
      },
      fill (event) {
        var val = event.target.value
        if (this.$refs.zjlx && this.$refs.zjlx[0].value === '身份证') {
          if (val && this.autoFill) {
            if (this.checkIDCard(val)) {
              var birthday = ''
              birthday = val.slice(6,14)
              birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-")
              this.$set(this.activityData, this.autoFill, birthday)
            } else {
              this.$toast.fail('身份证号填写错误')
              this.$set(this.activityData, this.autoFill, '')
            }
          } else if (this.autoFill) {
            this.$set(this.activityData, this.autoFill, '')
          }
        }
      },
      checkIDCard (idcode) {
        //身份证验证
        // 加权因子
        var weight_factor = [7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2];
        // 校验码
        var check_code = ['1', '0', 'X' , '9', '8', '7', '6', '5', '4', '3', '2'];

        var code = idcode + "";
        var last = idcode[17];//最后一位

        var seventeen = code.substring(0,17);

        // ISO 7064:1983.MOD 11-2
        // 判断最后一位校验码是否正确
        var arr = seventeen.split("");
        var len = arr.length;
        var num = 0;
        for(var i = 0; i < len; i++){
            num = num + arr[i] * weight_factor[i];
        }

        // 获取余数
        var resisue = num%11;
        var last_no = check_code[resisue];

        // 格式的正则
        // 正则思路
        /*
         第一位不可能是0
         第二位到第六位可以是0-9
         第七位到第十位是年份，所以七八位为19或者20
         十一位和十二位是月份，这两位是01-12之间的数值
         十三位和十四位是日期，是从01-31之间的数值
         十五，十六，十七都是数字0-9
         十八位可能是数字0-9，也可能是X
         */
        var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;

        // 判断格式是否正确
        var format = idcard_patter.test(idcode);

        // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
        return last === last_no && format ? true : false;
      }
    }
  }
</script>

<style lang="stylus">
  .pay_type
    padding 0
  .zpjj
    position relative
    .van-cell
      padding-bottom 20px !important
      textarea
        padding-bottom 20px !important
      .van-field__word-limit
        position absolute
        bottom 2px
        right 5px
        color #999
        margin-top 0
    .zpjjTips
      position absolute
      font-size 12px
      color #999
      right 5px
      bottom 2px
      line-height 16px
</style>